import { ReactNode, useCallback, useState } from "react";
import { NavLink } from "react-router";
import t from "@/lang/lang";
import { useOmniBaseDataServiceKind } from "../use-omni-base-data-service-kind";
import {
  ContractBaseDataTable,
  ContractBaseDataTableFilters,
  defaultOmniContractBaseDataListRequest,
} from "@/services/backend/omni/contract/components/contract-base-data-table";
import { CreateContractBaseDataDialog } from "@/services/backend/omni/contract/components/create-contract-base-data-dialog";
import {
  Card,
  CardAction,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";

export function OmniContractsBaseDataRoute() {
  const serviceKind = useOmniBaseDataServiceKind();
  const [request, setRequest] = useState(
    defaultOmniContractBaseDataListRequest(serviceKind),
  );

  const renderRowLink = useCallback(
    (baseDataId: string, children: ReactNode) => (
      <NavLink to={baseDataId}>{children}</NavLink>
    ),
    [],
  );

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Verträge")}</CardTitle>
        <CardDescription>
          {t(
            "Hier können Sie die Vorgabewerte verwalten, mit denen ein neuer Vertrag angelegt wird. Die als aktiv markierten Basisdaten werden dafür verwendet.",
          )}
        </CardDescription>
        <CardAction>
          <CreateContractBaseDataDialog serviceKind={serviceKind} />
        </CardAction>
      </CardHeader>
      <CardContent className="grid gap-2">
        <ContractBaseDataTableFilters
          request={request}
          onRequestChange={setRequest}
        />
        <ContractBaseDataTable
          request={request}
          onRequestChange={setRequest}
          renderRowLink={renderRowLink}
        />
      </CardContent>
    </Card>
  );
}
